import React, { useState } from 'react';
import { Button, Input, Space } from 'antd';
import { EditWrapper } from './styled';

function EditRCA({ lowerBound, onSave, onCancel }) {
  const [value, setValue] = useState(lowerBound);
  const [valid, setValid] = useState(true);

  const handleSave = () => {
    onSave({ lowerBound: Number(value) });
  };

  const validateInput = (inputValue) => {
    const v = Number(inputValue);
    if (v && v > 0 && v < 1000) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    validateInput(inputValue);
    setValue(inputValue);
  };

  return (
    <EditWrapper>
      <div>Analyze low performing Network Requests</div>
      <Space>
        <div>Average Network Duration &gt;</div>
        <Input
          onChange={handleChange}
          maxLength={3}
          value={value}
          addonAfter="sec"
          style={{ width: 100 }}
          status={valid ? '' : 'warning'}
        />
      </Space>
      <Space>
        <Button type="primary" size="small" onClick={handleSave} disabled={!valid}>
          Save
        </Button>
        <Button type="default" size="small" onClick={onCancel} disabled={false}>
          Cancel
        </Button>
      </Space>
    </EditWrapper>
  );
}

export default EditRCA;
